module.exports = __webpack_public_path__ + "static/media/football-association-of-ireland.b751db75.png";